import moment from 'moment';
import { SORT_TYPES } from './constants';

// https://momentjs.com/docs/#/parsing/string-format/
export const ISO_8601_FORMATS = {
  DATE: 'YYYY-MM-DD',
  TIME: 'HH:mm',
};
//
export const US_FORMATS = {
  DATE: 'MM-DD-YYYY',
  TIME: 'hh:mm A',
};

export const getDateFormat = me => {
  if (me) {
    return me.data.teams[0].useIsoTimeFormat
      ? ISO_8601_FORMATS.DATE
      : US_FORMATS.DATE;
  }
  return US_FORMATS.DATE;
};
export const getTimeFormat = me => {
  if (me) {
    return me.data.teams[0].useIsoTimeFormat
      ? ISO_8601_FORMATS.TIME
      : US_FORMATS.TIME;
  }
  return US_FORMATS.TIME;
};
export const getDateTimeFormat = () => {
  return `${getDateFormat()} ${getTimeFormat()}`;
};

export const dateCompare = (a = null, b = null, direction = SORT_TYPES.ASC) => {
  if (a === null) {
    return direction === SORT_TYPES.ASC ? 1 : -1;
  }
  if (b === null) {
    return direction === SORT_TYPES.ASC ? -1 : 1;
  }

  const first = new Date(a);
  const second = new Date(b);

  if (direction === SORT_TYPES.DESC) {
    return second - first;
  }

  // default ASC
  return first - second;
};

export function renderDate(date, me) {
  return moment(date).format(getDateFormat(me));
}

export function renderTime(date, me) {
  return moment(date).format(getTimeFormat(me));
}



// WEBPACK FOOTER //
// ./src/common/dateUtils.js